import React, { useEffect, useState } from "react";
import TopBar from "../../components/topBar/TopBar";
import { isMobile } from "react-device-detect";
import { Strings } from "../../utils/strings";
import { AiOutlineWarning } from "react-icons/ai";
import { useFontDesk } from "../../context/frontDeskContext";
import { StaticBackdropModal } from "../../components/modal/staticBackdropModal/StaticBackdropModal";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import "./ReedemLoyaltyPoints.css";
import { LoyaltyQRReedemData } from "../../types/types";
import { FrontDeskApi } from "../../apis/frontDesk.api";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";

export const ReedemLoyaltyPoints = () => {
  const [modalData, setModalData] = useState<{
    title: string;
    children: React.ReactNode | string;
    btnText?: string;
    btnVariant?: string;
    onClose: () => void;
    onAccept?: () => void;
    headerIcon?: React.ReactNode;
  }>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState<LoyaltyQRReedemData>();

  const { onLogOut } = useFontDesk();
  const navigate = useNavigate();

  const handleClose = async (_isLogout: boolean = false) => {
    setShow(false);
    setModalData(undefined);
  };

  const reedemQR = async () => {
    if (loading || show) return; // Prevent calling API if it's already in progress

    setLoading(true);
    try {
      await FrontDeskApi.reedemLoyaltyQR(data?.Id ?? 0, data?.UserId ?? "");
      setModalData({
        title: Strings.SUCCESS,
        children: "Loyalty Points has been redeemed successfully",
        btnText: Strings.OK,
        btnVariant: "success",
        onClose: () => {
          handleClose();
          navigate(-1);
        },
        onAccept: () => {
          handleClose();
          navigate(-1);
        },
      });
      setShow(true);
    } catch (e: any) {
      setModalData({
        title: Strings.ERROR,
        children: "Failed to redeem loyalty points",
        btnText: Strings.OK,
        btnVariant: "danger",
        onClose: () => {
          setData(undefined);
          handleClose();
        },
        onAccept: () => {
          setData(undefined);
          handleClose();
        },
      });
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data && !loading) {
      reedemQR();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <div className="loyalty-points-container">
        <TopBar
          isBack={isMobile}
          onLogout={() => {
            setModalData({
              title: Strings.LOGOUT,
              children: Strings.LOGOUT_WARNING,
              btnText: Strings.LOGOUT,
              btnVariant: "outline-danger",
              headerIcon: (
                <AiOutlineWarning
                  style={{
                    marginRight: "0.5em",
                    color: "red",
                    alignSelf: "center",
                  }}
                />
              ),
              onClose: () => {
                handleClose(true);
                onLogOut();
              },
            });
            setShow(true);
          }}
        />
        <h4 style={{ textAlign: "center" }}>
          Place your QR in front of below scanner to redeem loyalty points
        </h4>

        <div className="scanner-container">
          <BarcodeScannerComponent
            width="100%"
            height="auto"
            onUpdate={(_err, result) => {
              if (result && !data && !loading) {
                const text = result.getText();
                if (text.includes("code")) {
                  const code = text.split("=")[1];
                  const decodedCode = atob(code ?? "");
                  setData(JSON.parse(decodedCode));
                } else {
                  setData(JSON.parse(text));
                }
              }
            }}
          />
        </div>
        <StaticBackdropModal
          show={show}
          handleOpen={modalData?.onAccept ?? modalData?.onClose ?? handleClose}
          handleClose={handleClose}
          title={modalData?.title}
          children={modalData?.children}
          btnText={modalData?.btnText}
          headerIcon={modalData?.headerIcon}
        />
        <LoadingIndicator loading={loading} />
      </div>
    </>
  );
};
